var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { Breadcrumb as AntdBreadcrumb } from 'antd';
import { BreadcrumbItemContent } from './BreadcrumbItemContent';
import { BreadcrumbItem } from './BreadcrumbItem';
import { getConfigForPath } from './helpers';
var AntdItem = AntdBreadcrumb.Item;
var BreadcrumbComponent = function (_a) {
    var config = _a.config, pathname = _a.pathname, params = _a.params, Link = _a.Link, props = __rest(_a, ["config", "pathname", "params", "Link"]);
    var pathConfigArr = useMemo(function () { return getConfigForPath(pathname, params, config); }, [pathname, params, config]);
    return (React.createElement(AntdBreadcrumb, __assign({}, props), pathConfigArr.map(function (_a) {
        var link = _a.link, _b = _a.config, children = _b.children, icon = _b.icon, title = _b.title, _c = _b.isLink, isLink = _c === void 0 ? true : _c, isLast = _a.isLast;
        return children || (React.createElement(AntdItem, { key: link },
            React.createElement(BreadcrumbItem, { to: link, isLink: isLink && !isLast, LinkComponent: Link },
                React.createElement(BreadcrumbItemContent, { icon: icon, title: title }))));
    })));
};
BreadcrumbComponent.Item = AntdItem;
export { BreadcrumbComponent };
//# sourceMappingURL=Component.js.map